import { getService } from 'reducers/service';
import ServiceName from '../../shared/constants/serviceName';

export const getZoneAgencies = async () => {
  const response = await getService(ServiceName.PtsAgencies).find({ query: { IsDeleted: false } });
  return response?.data || response || [];
};

export const findDuplicateZones = async (ZoneCode) => {
  const response = await getService(ServiceName.CodeZones).find({
    query: { ZoneCode, IsDeleted: false },
  });
  return response?.data || response || [];
};

export const createZone = async (payload) => {
  const response = await getService(ServiceName.CodeZones).create(payload);
  return response?.data || response;
};

export const getZone = async (ZoneCode) => {
  const response = await getService(ServiceName.CodeZones).find({ query: { ZoneCode } });
  return (response?.data || response || [])[0];
};
export const updateZone = async (ZoneCode, payload) => {
  const response = await getService(ServiceName.CodeZones).patch(ZoneCode, payload);
  return response?.data || response;
};
